let d3 = window.d3 || null;

let brainRenderOption = (graph) => {
    graph.option.d3 && (d3 = graph.option.d3);
    let scale = graph.option.scale;
    let circleRadiusMap = { '0': 38 + 36, '1': 16 + 36, '2': 10 + 36, '3': 8 + 36, };
    let entityType = graph.option.entityType;
    if (entityType === 'user') {
        circleRadiusMap = { '0': 112, '1': 64, '2': 40, '3': 18, };
    }
    // 调整节点大小
    if (window._screenType === '2160') {
        circleRadiusMap = { '0': 160, '1': 100, '2': 90, '3': 60, };
    } else {
        for (let key in circleRadiusMap) {
            circleRadiusMap[key] = circleRadiusMap[key] * scale;
        }
    }


    let renderOptionObj = {
        lockGroupExtend(lockGroup) {
            lockGroup
                .selectAll('circle')
                .attr('r', d => circleRadiusMap[d.depth] || 100)
                .attr('class', function (d) {
                    let className = this.getAttribute('class');
                    className += ` node-depth-${d.depth}`;
                    return className;
                });
        },
        drawLinkExtend(linksGroup) {
            linksGroup
                .attr('class', function (d) {
                    let className = this.getAttribute('class');
                    let sourceNode = graph.data.nodes.find(_ => _.id === d.source);
                    let targetNode = graph.data.nodes.find(_ => _.id === d.target);
                    if (sourceNode && targetNode) {
                        className += ` link-depth-${sourceNode.depth}`;
                    } else {
                        debugger
                    }
                    if (entityType === 'user') {
                        className += ' user-links';
                    }
                    return className;
                });
        },
        drawNodeExtend(nodesGroup) {
            nodesGroup
                .attr('id', d => `node-${d.id}`)
                .attr('class', function (d) {
                    let className = this.getAttribute('class');
                    className += ` node-depth-${d.depth} node-group-${d.group}`;
                    (d.isleaf === '1') && (className += ' leaf');
                    (d.depth === '0') && (className += ' kg-force-node-wrap-root');
                    return className;
                });

            // let imageUrl = {
            //     'blue-light': 'https://s3plus.meituan.net/v1/mss_814dc1610cda4b2e8febd6ea2c809db5/distribute/c0115ddb-e7e0-42b7-806d-6f55445fd3a2_1545033859376?filename=CES%E5%A4%A7%E5%B1%8F%E6%9C%80%E6%96%B0_20.png',
            //     'blue-dark': 'https://s3plus.meituan.net/v1/mss_814dc1610cda4b2e8febd6ea2c809db5/distribute/575e9814-3349-4fda-b5c3-5fc180ee5fd0_1545033859377?filename=CES%E5%A4%A7%E5%B1%8F%E6%9C%80%E6%96%B0_23.png',
            //     'yellow': 'https://s3plus.meituan.net/v1/mss_814dc1610cda4b2e8febd6ea2c809db5/distribute/492fdd11-e0fa-440f-b425-600a49e41e94_1545033946857?filename=CES%E5%A4%A7%E5%B1%8F%E6%9C%80%E6%96%B0_34.png',
            //     'purple': 'https://s3plus.meituan.net/v1/mss_814dc1610cda4b2e8febd6ea2c809db5/distribute/e1ab7204-b4cd-4bf1-be82-7cea904c6a60_1545033946798?filename=CES%E5%A4%A7%E5%B1%8F%E6%9C%80%E6%96%B0_09.png',
            // };
            // imageUrl[0] = imageUrl['blue-light'];
            // imageUrl[1] = imageUrl['blue-light'];
            // imageUrl[2] = imageUrl['yellow'];
            // imageUrl[3] = imageUrl['blue-light'];
            let imageUrl = {
                'blue': 'https://s3plus.meituan.net/v1/mss_78d1aa5426c546bfa023ca0cacfa2cd1/distribute/3f78cecd-7600-4992-9d16-a915f4f473fb_1551512033357?filename=1.png',
                'green': 'https://s3plus.meituan.net/v1/mss_78d1aa5426c546bfa023ca0cacfa2cd1/distribute/41b8904f-3d3b-440a-ad47-06919563f97b_1551512033371?filename=2.png',
                'yellow': 'https://s3plus.meituan.net/v1/mss_78d1aa5426c546bfa023ca0cacfa2cd1/distribute/afe029cd-25a0-4a0e-988c-9bb94a7f1584_1551512033359?filename=3.png'
            };
            imageUrl[0] = imageUrl['blue'];
            imageUrl[1] = imageUrl['yellow'];
            imageUrl[2] = imageUrl['green'];
            imageUrl[3] = imageUrl['blue'];

            let textColor = {
                0: '#2766B2',
                1: '#7A7111',
                2: '#0EBEC1',
                3: '#2766B2'
            };

            if (entityType === 'user') {
                imageUrl[0] = 'http://s3plus.sankuai.com/v1/mss_c9d411db85ec4b59aaebc4dfca416c55/image-hosting/0-kg-brain-case/中心节点@2x.png';
                imageUrl[1] = 'http://s3plus.sankuai.com/v1/mss_c9d411db85ec4b59aaebc4dfca416c55/image-hosting/0-kg-brain-case/一级节点@2x.png';
                imageUrl[2] = 'http://s3plus.sankuai.com/v1/mss_c9d411db85ec4b59aaebc4dfca416c55/image-hosting/0-kg-brain-case/二级节点@2x.png';
                imageUrl[3] = 'http://s3plus.sankuai.com/v1/mss_c9d411db85ec4b59aaebc4dfca416c55/image-hosting/0-kg-brain-case/三级节点@2x.png';
                textColor = {
                    0: '#F5844E',
                    1: '#CFB72A',
                    2: '#009B94',
                    3: '#358CE9'
                };
            }

            // 中心节点特殊化
            let userIcon = 'M19.134 17.505h-5.108C9.567 17.505 6 21.166 6 25.641v.488C6 28 9.567 28 13.945 28h5.108C23.431 28 27 27.919 27 26.129v-.488c.08-4.475-3.487-8.136-7.865-8.136zm-8.837-7.24c0 3.416 2.757 6.264 6.243 6.264s6.243-2.766 6.243-6.265A6.256 6.256 0 0 0 16.54 4c-3.405 0-6.243 2.847-6.243 6.264z';
            let poiIcon = 'M24.114 19.622c-1.307 0-2.429-.672-2.887-1.622-.453.95-1.562 1.622-2.856 1.622-1.293 0-2.403-.672-2.856-1.622-.458.95-1.579 1.622-2.886 1.622-1.294 0-2.403-.672-2.856-1.622-.458.95-1.58 1.622-2.887 1.622-.308 0-.605-.04-.886-.11v5.377C6 25.39 6.656 26 7.247 26h16.506c.59 0 1.247-.611 1.247-1.11v-5.376a3.69 3.69 0 0 1-.886.108zM24.963 9H5.97L4 13.523C4 14.877 5.281 16 6.859 16c1.577 0 2.891-1.095 2.891-2.477 0 1.354 1.281 2.477 2.859 2.477 1.577 0 2.89-1.095 2.89-2.477 0 1.354 1.282 2.477 2.86 2.477 1.577 0 2.858-1.095 2.858-2.477C21.217 14.877 22.5 16 24.11 16 25.686 16 27 14.905 27 13.523L24.963 9zM6.964 8h16.072c.546 0 .964-.433.964-1s-.418-1-.964-1H6.964C6.418 6 6 6.433 6 7s.418 1 .964 1z';

            // 主体
            nodesGroup.selectAll('.kg-force-node-entity').remove();
            nodesGroup
                .append('image')
                .attr('width', d => circleRadiusMap[d.depth])
                .attr('height', d => circleRadiusMap[d.depth])
                .attr('href', d => imageUrl[d.depth])
                .style('transform', d => `translate(-${(circleRadiusMap[d.depth] || 100) / 2}px, -${(circleRadiusMap[d.depth] || 100) / 2}px)`)
                .attr('class', (d) => {
                    let className = 'kg-force-node kg-force-node-entity';
                    className += ` node-depth-${d.depth}`;
                    return className;
                });

            // 背景控制 暂时关了
            nodesGroup.selectAll('.kg-force-node-bg')
                .attr('r', d => (circleRadiusMap[d.depth]) / 2 + 3)
                .attr('class', function (d) {
                    let className = this.getAttribute('class');
                    className += ` node-depth-${d.depth}`;
                    return className;
                });

            let baseFontDefault = 14;
            let baseFont = {
                0: 16
            };
            if (entityType === 'user') {
                baseFont = {
                    0: 22,
                    1: 19,
                    2: 18,
                    3: 16,
                    4: 14,
                };
            }
            // 文字控制
            nodesGroup.selectAll('.kg-force-text')
                .style('fill', (d) => {
                    return textColor[d.depth];
                })
                .style('font-size', d => baseFont && baseFont[d.depth] ? `${baseFont[d.depth] * scale}px` : `${baseFontDefault * scale}px`)
                // .attr('dx', d => circleRadiusMap[d.depth] + 8 + 'px');
                .attr('dx', d => {
                    if (entityType === 'user' && d.depth === '0') {
                        return circleRadiusMap[d.depth] / 2 - 5 + 'px';
                    }
                    return circleRadiusMap[d.depth] / 2 + 5 + 'px';
                })
                .attr('dy', '5px');

            // devHack
            // POI用红色的文字表示
            if ($qsObj && $qsObj.force === 'true') {
                nodesGroup.selectAll('.kg-force-text').style('fill', d => d.type.includes('POI') ? 'orange' : undefined);
                nodesGroup.selectAll('.kg-force-node-wrap-root .kg-force-text').style('fill', 'red');
            }
            if ($qsObj && $qsObj.forcedebug === 'true') {
                nodesGroup.selectAll('.kg-force-text').style('fill', d => d.type.includes('POI') ? '#fff' : undefined);
                nodesGroup.selectAll('.kg-force-node-wrap-root .kg-force-text').style('fill', '#fff');
                nodesGroup.selectAll('.kg-force-text').style('fill', d => !d.isLeaf ? 'red' : undefined);
            }
        },
        onClick(item, index, array) {
            d3.event.stopPropagation(); // 阻止冒泡到全局
            let boomClassNameList = ['kg-force-node-bg', 'kg-force-node-entity'];
            let eventTarget = d3.event.target;
            let boomFlag = false;
            boomClassNameList.forEach((clsStr) => eventTarget.classList.contains(clsStr) && (boomFlag = true));
            if (!boomFlag) {
                return void 0;
            }

            let curLinks = graph.data.links.filter(_ => _.source.id === item.id);
            let curTargetNodes = curLinks.map(_ => _.target);
            graph.simulation.force('collide', d3.forceCollide().radius((d) => {
                if (curTargetNodes.includes(d)) {
                    return 50 * scale;
                }

                // let radius = 10;
                // let depthMap = { 0: 150, 1: 50, 2: 70, 3: 20 };
                // radius = depthMap[d.depth] * scale;
                // if (d.isLeaf && d.depth === '2') {
                //     radius = 20 * scale;
                // }
                // return radius;

                let is2160 = () => window._screenType === '2160';
                let radius = 10;
                // 调整节点碰撞半径
                let depthMap = { 0: 150, 1: 50, 2: 70, 3: 20 };
                if (is2160()) {
                    // depthMap = { 0: 130, 1: 60, 2: 90, 3: 20 };
                    depthMap = { 0: 120, 1: 60, 2: 90, 3: 20 };
                    // depthMap[3] = 0
                }
                radius = depthMap[d.depth] * scale;
                if (d.isLeaf && d.depth === '2') {
                    radius = 20 * scale;
                }
                // if (d.depth === '1') {
                //     return 200;
                // }
                return radius;
            }));
        },
        customSetHighLight(d) {
            let nextDeepMap = { 0: 1, 1: 2 };
            let nextDeep = nextDeepMap[d.depth] || 1; // 向前或者向后找的层级的深度

            let nodeArr = [d]; // 高亮的节点
            let linkArr = []; // 高亮的线

            graph.findLinkedRoute(d, 'source', nextDeep, nodeArr, linkArr); // 向子节点找几层
            graph.findLinkedRoute(d, 'target', Infinity, nodeArr, linkArr); // 向父节点找几层
            graph.pureHighlight(nodeArr, linkArr);
        }
    };

    return renderOptionObj;
};

export default brainRenderOption;
